// context/PhotoEditorContext.js - Context for managing photo editor state
import React, { createContext, useContext, useRef, useMemo, useState } from 'react';

// Create the context
const PhotoEditorContext = createContext({});

// Provider component
export const PhotoEditorProvider = ({ children, value }) => {
  const originalSizeCanvasRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const parentElementRef = useRef(null);
  
  // State for tracking adjustments
  const [adjustments, setAdjustments] = useState({
    brightness: 100,
    contrast: 100,
    saturation: 100,
    blur: 0,
    invert: false
  });
  
  // State for tracking transformations
  const [transformations, setTransformations] = useState({
    cropRatio: null,
    rotation: 0,
    flipped: { horizontal: false, vertical: false }
  });
  
  // Combine all values into context
  const contextValue = useMemo(() => ({
    ...value,
    originalSizeCanvasRef,
    previewCanvasRef,
    parentElementRef,
    adjustments,
    setAdjustments,
    transformations,
    setTransformations
  }), [value, adjustments, transformations]);

  return (
    <PhotoEditorContext.Provider value={contextValue}>
      {children}
    </PhotoEditorContext.Provider>
  );
};

// Custom hook for accessing the context
export const usePhotoEditorContext = () => useContext(PhotoEditorContext);
